import { useSelector } from 'react-redux';
import useCardView from '../../../../hooks/useCardView';
import classnames from 'classnames';
import React from 'react';
import TRANSLATIONS from '../translations@default.json';
import { savingsPercentage } from '../../../../utilities/number-utilities';
import FormatterV1 from './FormatterV1';

export const SaveWasContainerV1 = ({
	was,
	save,
	displayWasPrice,
	displayMemberPrice,
	enhancedCardLayout = false,
}) => {
	const { isDealsPage } = useSelector((state) => state);
	const { isGridView, isListView } = useCardView();

	return (
		<div
			className={classnames('flex text-body-xs saving-price lg:justify-end', {
				'xl:flex-col xl:ml-1':
					!isDealsPage && isGridView && !enhancedCardLayout,
				'lg:flex-row-reverse': isDealsPage && isListView,
				'flex-col': enhancedCardLayout,
				'xl:ml-1': !enhancedCardLayout
			})}>
			<div
				className={classnames('font-bold text-deals', {
					'lg:ml-1': isDealsPage && isListView,
					'mb-1': enhancedCardLayout,
				})}>
				{!isDealsPage || (isDealsPage && save >= 100) ? (
					<React.Fragment>
						{TRANSLATIONS.save}{' '}
						<span data-testid="price-save">{FormatterV1.format(save)}</span>
					</React.Fragment>
				) : (
					<React.Fragment>
						{TRANSLATIONS.saving}{' '}
						<span data-testid="price-percentage">
							{savingsPercentage(was, save)}
						</span>
					</React.Fragment>
				)}
			</div>

			<div
				className={classnames({
					'text-tertiary ml-1 font-regular':
						!isDealsPage && !enhancedCardLayout,
					'xl:ml-0': !isDealsPage && isGridView,
					'ml-0 font-regular': enhancedCardLayout,
				})}>
				{displayWasPrice ? TRANSLATIONS.was : TRANSLATIONS.RRP}{' '}
				<span
					data-testid={displayWasPrice ? 'price-was' : 'price-rrp'}
					className={displayWasPrice ? '' : 'line-through'}>
					{FormatterV1.format(was)}
				</span>
			</div>
		</div>
	);
};
